import React from "react";
import "./roadmap.css";
import img from "../../assets/image 1.png";
import { AiFillCheckCircle } from "react-icons/ai";

function Roadmap() {
  return (
    <section className="container roadmap_container" id="roadmap">
      <div className="title">
        <h5>So Far</h5>
        <h2>Our Roadmap</h2>
      </div>

      <div className="roadmap_main">
        <img src={img} />
        <div className="list">
          <ul>
            <li>
              <span>Roadmap 1.0</span>
            </li>
            <br></br>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>Develop the front-end and back-end.</span>
            </li>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>Design the NFT collection .</span>
            </li>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>Launch the website .</span>
            </li>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>
                Build the MonkeyDoo community by launching Social platforms.
              </span>
            </li>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>
                Deploy the smart contract on the mainnet: start minting.
              </span>
            </li>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>Open Marketplace when sold out.</span>
            </li>
          </ul>
        </div>
      </div>
      <div
        className="roadmap_main"
        style={{
          height: "inherit",
        }}
      >
        <img src={img} />
        <div
          className="list"
          // style={{
          //   marginLeft: "23rem",
          // }}
        >
          <ul>
            <li>
              <span>Roadmap 2.0</span>
            </li>
            <br></br>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>
                A collection of 3000 3D MonkeyDoos will be deployed on the
                Ethereum blockchain. The price of an ETH MKD is set at 0.1 ETH.
                Profits will be shared with the ETC MKD holders: 100% with the
                top 10 rarity holders and 20% for the other rarity holders.
              </span>
            </li>
            <br></br>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>Launch MonkeyDoo Mutants on Ethereum Classic</span>
            </li>
            <br></br>
            <li>
              <AiFillCheckCircle className="check_icon" />{" "}
              <span>
                Develop a Merchandise webstore where MonkeyDoo Merchandise will
                be sold. Profits will be shared with the ETC MKD holders: 100%
                with the top 10 rarity holders and 20% for other rarity holders.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Roadmap;
